import React from "react";
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import Footer from "./components/footer/footer";
import Form from './components/form/Auth';
import Home from "./components/home/Home";
import Jackpot from "./components/jackpots/jackpot";
import Sportpesa from "./components/jackpots/sportpesa";
import Betika from './components/jackpots/betika';
import SportyBet from './components/jackpots/sportybet';
import Betpawa from './components/jackpots/betpawa';
import BongoBongo from './components/jackpots/bongobongo';
import Mozzart from './components/jackpots/mozzart';
import Navbar from './components/navbar/navbar';
import VIP from "./components/VIPs/VIP";
import FixedMatches from "./components/VIPs/fixedMatches";
import Premium from "./components/VIPs/premium";
import Multibets from "./components/VIPs/multibets";
import ResponsiveDrawer  from './components/navbar/drawe-nav';
import FloatingButton from "./components/floatingButtons/floatingActionButton";
import Pricing from "./components/pricing/pricing";
import Blog from "./components/blog/blog";
import PopularDetails from "./components/popular/popularDetails";

const App = () => {
  return (
    <BrowserRouter>
      <Navbar />
      <FloatingButton/>
      <Routes>
        <Route exact path="/" element={<Home />} />
        <Route exact path="/login" element={<Form />} />
        <Route exact path="/Premium" element={<Premium/>} />
        <Route exact path="/VIP" element={<VIP/>} />
        <Route exact path="/Fixed-Matches" element={<FixedMatches/>} />
        <Route exact path="/Jackpots" element={<Jackpot />} />
        <Route exact path="/Sportpesa" element={<Sportpesa />} />
        <Route exact path="/Betika" element={<Betika/>} />
        <Route exact path="/BetPawa" element={<Betpawa/>} />
        <Route exact path="/SportyBet" element={<SportyBet/>} />
        <Route exact path="/Mozzart" element={<Mozzart/>} />
        <Route exact path="/BongoBongo" element={<BongoBongo/>} />
        <Route exact path="/Multibets" element={<Multibets/>} />
        <Route exact path="/Pricing" element={<Pricing/>} />
        <Route exact path="/Popular" element={<PopularDetails/>} />
        <Route exact path="/Blog" element={<Blog/>} />
      </Routes>
      <Footer />
    </BrowserRouter>
  );
}

export default App;
